// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"d6d21d78","70":"17a35a9d","101":"59045a33","397":"87584e70","531":"169de0d0","752":"f1542cc6"}[chunkId] + ".chunk.js";
};